import {
    Component,
    Output,
    Input,
    EventEmitter,
    OnChanges,
    AfterViewInit,
    SimpleChange,
    ChangeDetectionStrategy,
    NgZone,
    ElementRef,
    ViewChild,
    Renderer
} from '@angular/core';
import { DCTreeHolder } from './dc-tree-holder.component';
import { TreeService, TreeNode } from '../../../../../common/tree';

@Component({
    selector: 'dc-tree-main',
    template: `
       <div>
        <dc-tree-holder 
            [url]="url" 
            [state]="state" 
            [actionsMap]="menuActionMapping" 
            [linksMap]="menuLinksMapping" 
            autofocus
            [entityType]="entityType"
            [nodeToBeSelectedOnLoad]="nodeToBeSelectedOnLoad">
        </dc-tree-holder>
      </div>
    `
})
export class DCTreeMain implements AfterViewInit {
    @Input() state: any;
    @Input() entityType: string;
    @Input() vcenterId: string;
    @Input() nodeToBeSelectedOnLoad: string;
    show: boolean;
    @Output() onShow = new EventEmitter();
    @ViewChild('treeview') treeView: DCTreeHolder;
    url: String;
    menuActionMapping: any;
    menuLinksMapping: any;
    constructor(private element: ElementRef,
                private renderer: Renderer, private ngZone: NgZone) {
        this.show = true;
    }

    ngOnInit() {
        this.renderer.invokeElementMethod(this.element.nativeElement, 'focus', []);
    }

    ngAfterViewInit() {
        // TODO Find the first root node and preselect
    }

    ngOnChanges(changes: {[propertyName: string]: SimpleChange}) {
        if (this.entityType && this.vcenterId) {
           this.url = '/hybridity/api/vc/query?entityType=' + this.entityType + '&filter=vcenterId==' + this.vcenterId;
        }
    }

    toggleState() {
        this.show = !this.show;
        if (this.show) {
            this.onShow.emit(this.show);
            this.renderer.invokeElementMethod(this.element.nativeElement, 'focus', []);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/administration-main/deployment-container/dc-tree/dc-tree-main.component.ts